import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
export class GeneralUIContent {
  get descriptor() {
    return GeneralUIContent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasTitle = false;
    this._title = null;
    this._hasSubTitle = false;
    this._subTitle = null;
    this._hasContent = false;
    this._content = null;
    this._hasThumbnail = false;
    this._thumbnail = null;
    this._childrenContent = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasTitle) return false;
    if (this._hasSubTitle) return false;
    if (this._hasContent) return false;
    if (this._hasThumbnail) return false;
    if (this._childrenContent.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GeneralUIContent) {
      return value;
    }
    return GeneralUIContent.fromJson(value);
  }
  static fromJson(json) {
    const result = new GeneralUIContent();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.title != null) {
      result._hasTitle = true;
      result._title = JsonToString.fromJson(json.title);
    }
    if (json.subTitle != null) {
      result._hasSubTitle = true;
      result._subTitle = JsonToString.fromJson(json.subTitle);
    }
    if (json.content != null) {
      result._hasContent = true;
      result._content = JsonToString.fromJson(json.content);
    }
    if (json.thumbnail != null) {
      result._hasThumbnail = true;
      result._thumbnail = JsonToString.fromJson(json.thumbnail);
    }
    result._childrenContent = JsonToList(json.childrenContent, GeneralUIContent);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasTitle) {
      result.title = JsonToString.toJson(this._title);
    }
    if (this._hasSubTitle) {
      result.subTitle = JsonToString.toJson(this._subTitle);
    }
    if (this._hasContent) {
      result.content = JsonToString.toJson(this._content);
    }
    if (this._hasThumbnail) {
      result.thumbnail = JsonToString.toJson(this._thumbnail);
    }
    if (this._childrenContent.length > 0) {
      result.childrenContent = ArrayToJson(this._childrenContent, GeneralUIContent);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get title() {
    return this._hasTitle ? this._title : JsonToString.default;
  }
  get hasTitle() {
    return this._hasTitle;
  }
  setTitle(path, value) {
    return {type: 'SET', path: path.concat(['title']), value};
  }
  deleteTitle(path) {
    return {type: 'DELETE', path: path.concat(['title'])};
  }
  /**
   * @returns {string}
   */
  get subTitle() {
    return this._hasSubTitle ? this._subTitle : JsonToString.default;
  }
  get hasSubTitle() {
    return this._hasSubTitle;
  }
  setSubTitle(path, value) {
    return {type: 'SET', path: path.concat(['subTitle']), value};
  }
  deleteSubTitle(path) {
    return {type: 'DELETE', path: path.concat(['subTitle'])};
  }
  /**
   * @returns {string}
   */
  get content() {
    return this._hasContent ? this._content : JsonToString.default;
  }
  get hasContent() {
    return this._hasContent;
  }
  setContent(path, value) {
    return {type: 'SET', path: path.concat(['content']), value};
  }
  deleteContent(path) {
    return {type: 'DELETE', path: path.concat(['content'])};
  }
  /**
   * @returns {string}
   */
  get thumbnail() {
    return this._hasThumbnail ? this._thumbnail : JsonToString.default;
  }
  get hasThumbnail() {
    return this._hasThumbnail;
  }
  setThumbnail(path, value) {
    return {type: 'SET', path: path.concat(['thumbnail']), value};
  }
  deleteThumbnail(path) {
    return {type: 'DELETE', path: path.concat(['thumbnail'])};
  }
  /**
   * @returns {GeneralUIContent[]}
   */
  get childrenContent() {
    return this._childrenContent;
  }
  addChildrenContent(path, value) {
    return {type: 'ADD', path: path.concat(['childrenContent']), value: value.toJson()};
  }
  setChildrenContent(path, value) {
    return {type: 'SET', path: path.concat(['childrenContent']), value: ArrayToJson(value, GeneralUIContent)};
  }
  setChildrenContentByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['childrenContent', key]), value: value.toJson()};
  }
  deleteChildrenContent(path) {
    return {type: 'DELETE', path: path.concat(['childrenContent'])};
  }
  deleteChildrenContentByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['childrenContent', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GeneralUIContent(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new GeneralUIContent(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "title": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GeneralUIContent(this);
              copy._hasTitle = true;
              copy._title = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTitle) {
                return this;
              }
              const copy = new GeneralUIContent(this);
              copy._hasTitle = false;
              copy._title = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "subTitle": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GeneralUIContent(this);
              copy._hasSubTitle = true;
              copy._subTitle = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSubTitle) {
                return this;
              }
              const copy = new GeneralUIContent(this);
              copy._hasSubTitle = false;
              copy._subTitle = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "content": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GeneralUIContent(this);
              copy._hasContent = true;
              copy._content = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasContent) {
                return this;
              }
              const copy = new GeneralUIContent(this);
              copy._hasContent = false;
              copy._content = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "thumbnail": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GeneralUIContent(this);
              copy._hasThumbnail = true;
              copy._thumbnail = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasThumbnail) {
                return this;
              }
              const copy = new GeneralUIContent(this);
              copy._hasThumbnail = false;
              copy._thumbnail = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "childrenContent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GeneralUIContent(this);
              copy._childrenContent = [];        for (let i of value) {
                copy._childrenContent.push(GeneralUIContent.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GeneralUIContent(this);
              copy._childrenContent = copy._childrenContent.concat([GeneralUIContent.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._childrenContent.length === 0) {
                return this;
              }
              const copy = new GeneralUIContent(this);
              copy._childrenContent = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._childrenContent.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GeneralUIContent(this);
              copy._childrenContent = copy._childrenContent.slice();
              copy._childrenContent[path[1]] = GeneralUIContent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GeneralUIContent(this);
              copy._childrenContent = copy._childrenContent.slice(0, path[1]).concat(copy._childrenContent.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._childrenContent.length) {
            return this;
          }
          const oldValue = this._childrenContent[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GeneralUIContent(this);
          copy._childrenContent = copy._childrenContent.slice();
          copy._childrenContent[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GeneralUIContent} other
   * @returns {GeneralUIContent}
   */
  merge(other) {
    const copy = new GeneralUIContent(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasTitle) {
      copy._hasTitle = true;
      copy._title = other._title;
    }
    if (other._hasSubTitle) {
      copy._hasSubTitle = true;
      copy._subTitle = other._subTitle;
    }
    if (other._hasContent) {
      copy._hasContent = true;
      copy._content = other._content;
    }
    if (other._hasThumbnail) {
      copy._hasThumbnail = true;
      copy._thumbnail = other._thumbnail;
    }
    copy._childrenContent = this._childrenContent.concat(other._childrenContent);
    return copy;
  }
}
GeneralUIContent.default = new GeneralUIContent();
class GeneralUIContent_Builder {
  constructor(value) {
    this._value = new GeneralUIContent(value);
  }
  build() {
    return new GeneralUIContent(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setTitle(value) {
    this._value._hasTitle = true;
    this._value._title = value;
    return this;
  }
  deleteTitle() {
    this._value._hasTitle = false;
    this._value._title = null;
    return this;
  }
  setSubTitle(value) {
    this._value._hasSubTitle = true;
    this._value._subTitle = value;
    return this;
  }
  deleteSubTitle() {
    this._value._hasSubTitle = false;
    this._value._subTitle = null;
    return this;
  }
  setContent(value) {
    this._value._hasContent = true;
    this._value._content = value;
    return this;
  }
  deleteContent() {
    this._value._hasContent = false;
    this._value._content = null;
    return this;
  }
  setThumbnail(value) {
    this._value._hasThumbnail = true;
    this._value._thumbnail = value;
    return this;
  }
  deleteThumbnail() {
    this._value._hasThumbnail = false;
    this._value._thumbnail = null;
    return this;
  }
  addAllChildrenContent(values) {
    this._value._childrenContent = this._value._childrenContent.concat(values);
    return this;
  }
  addChildrenContent(value) {
    this._value._childrenContent = this._value._childrenContent.concat([value]);
    return this;
  }
  setChildrenContent(index, value) {
    this._value._childrenContent = this._value._childrenContent.concat();
    this._value._childrenContent[index] = value;
    return this;
  }
  clearChildrenContent() {
    this._value._childrenContent = [];
    return this;
  }
}
GeneralUIContent.Builder = GeneralUIContent_Builder;
class GeneralUIContent_WithParent {
  /**
   * @param {GeneralUIContent} value
   * @param {GeneralUIContent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GeneralUIContent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasTitle() {
    if (this._cachedHasTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedHasTitle = true;
      } else {
        this._cachedHasTitle = this._parent ? this._parent.hasTitle : false;
      }
    }
    return this._cachedHasTitle;
  }
  get title() {
    if (this._cachedTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedTitle = this._value.title;
      } else {
        this._cachedTitle = this._parent ? this._parent.title : this._value.title;
      }
    }
    return this._cachedTitle;
  }
  get hasSubTitle() {
    if (this._cachedHasSubTitle === undefined) {
      if (this._value.hasSubTitle) {
        this._cachedHasSubTitle = true;
      } else {
        this._cachedHasSubTitle = this._parent ? this._parent.hasSubTitle : false;
      }
    }
    return this._cachedHasSubTitle;
  }
  get subTitle() {
    if (this._cachedSubTitle === undefined) {
      if (this._value.hasSubTitle) {
        this._cachedSubTitle = this._value.subTitle;
      } else {
        this._cachedSubTitle = this._parent ? this._parent.subTitle : this._value.subTitle;
      }
    }
    return this._cachedSubTitle;
  }
  get hasContent() {
    if (this._cachedHasContent === undefined) {
      if (this._value.hasContent) {
        this._cachedHasContent = true;
      } else {
        this._cachedHasContent = this._parent ? this._parent.hasContent : false;
      }
    }
    return this._cachedHasContent;
  }
  get content() {
    if (this._cachedContent === undefined) {
      if (this._value.hasContent) {
        this._cachedContent = this._value.content;
      } else {
        this._cachedContent = this._parent ? this._parent.content : this._value.content;
      }
    }
    return this._cachedContent;
  }
  get hasThumbnail() {
    if (this._cachedHasThumbnail === undefined) {
      if (this._value.hasThumbnail) {
        this._cachedHasThumbnail = true;
      } else {
        this._cachedHasThumbnail = this._parent ? this._parent.hasThumbnail : false;
      }
    }
    return this._cachedHasThumbnail;
  }
  get thumbnail() {
    if (this._cachedThumbnail === undefined) {
      if (this._value.hasThumbnail) {
        this._cachedThumbnail = this._value.thumbnail;
      } else {
        this._cachedThumbnail = this._parent ? this._parent.thumbnail : this._value.thumbnail;
      }
    }
    return this._cachedThumbnail;
  }
  get selfChildrenContent() {
    if (!this._selfChildrenContent) {
      this._selfChildrenContent = [];
      for (let i of this._value.childrenContent) {
        this._selfChildrenContent.push(new GeneralUIContent.WithParent(i, null));
      }
    }
    return this._selfChildrenContent;
  }
  get inherentChildrenContent() {
    if (!this._inherentChildrenContent) {
      this._inherentChildrenContent = this._parent ? this._parent.childrenContent : [];
    }
    return this._inherentChildrenContent;
  }
  get childrenContent() {
    if (!this._allChildrenContent) {
      this._allChildrenContent = this._parent ? this._parent.childrenContent.concat(this.selfChildrenContent) : this.selfChildrenContent;
    }
    return this._allChildrenContent;
  }
  update(current, parent) {
    const result = new GeneralUIContent_WithParent(current, parent);
    if (this._selfChildrenContent) {
      if (this._value.childrenContent === current.childrenContent) {
        result._selfChildrenContent = this._selfChildrenContent;
      } else {
        result._selfChildrenContent = [];
        for (let i = 0; i < current.childrenContent.length; i++) {
          const oldValue = this._value.childrenContent[i];
          if (oldValue) {
            const oldCache = this._selfChildrenContent[i];
            if (oldValue === current.childrenContent[i]) {
              result._selfChildrenContent[i] = oldCache;
            } else {
              result._selfChildrenContent[i] = oldCache.update(current.childrenContent[i], null);
            }
          } else {
            result._selfChildrenContent[i] = new GeneralUIContent.WithParent(current.childrenContent[i], null);
          }
        }
      }
    }
    return result;
  }
}
GeneralUIContent_WithParent.default = new GeneralUIContent_WithParent(GeneralUIContent.default, null);
GeneralUIContent.WithParent = GeneralUIContent_WithParent;
class GeneralUIContent_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get title() {
    if (!this._title) {
      this._title = {
        name: "title",
        Name: "Title",
        number: 2,
        protoType: 9,
        protoName: "title",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._title;
  }
  get subTitle() {
    if (!this._subTitle) {
      this._subTitle = {
        name: "subTitle",
        Name: "SubTitle",
        number: 3,
        protoType: 9,
        protoName: "sub_title",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subTitle;
  }
  get content() {
    if (!this._content) {
      this._content = {
        name: "content",
        Name: "Content",
        number: 4,
        protoType: 9,
        protoName: "content",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._content;
  }
  get thumbnail() {
    if (!this._thumbnail) {
      this._thumbnail = {
        name: "thumbnail",
        Name: "Thumbnail",
        number: 5,
        protoType: 9,
        protoName: "thumbnail",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._thumbnail;
  }
  get childrenContent() {
    if (!this._childrenContent) {
      this._childrenContent = {
        name: "childrenContent",
        Name: "ChildrenContent",
        number: 6,
        protoType: 11,
        protoName: "children_content",
        type: GeneralUIContent,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._childrenContent;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.title,
        this.subTitle,
        this.content,
        this.thumbnail,
        this.childrenContent,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTitle",
        Name: "DummyOneofForTitle",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSubTitle",
        Name: "DummyOneofForSubTitle",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForContent",
        Name: "DummyOneofForContent",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForThumbnail",
        Name: "DummyOneofForThumbnail",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
GeneralUIContent.descriptor = new GeneralUIContent_Descriptor();
export class Compendium {
  get descriptor() {
    return Compendium.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._tabs = [];
  }
  isEmpty() {
    if (this._tabs.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Compendium) {
      return value;
    }
    return Compendium.fromJson(value);
  }
  static fromJson(json) {
    const result = new Compendium();
    result._tabs = JsonToList(json.tabs, GeneralUIContent);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._tabs.length > 0) {
      result.tabs = ArrayToJson(this._tabs, GeneralUIContent);
    }
    return result;
  }
  /**
   * @returns {GeneralUIContent[]}
   */
  get tabs() {
    return this._tabs;
  }
  addTabs(path, value) {
    return {type: 'ADD', path: path.concat(['tabs']), value: value.toJson()};
  }
  setTabs(path, value) {
    return {type: 'SET', path: path.concat(['tabs']), value: ArrayToJson(value, GeneralUIContent)};
  }
  setTabsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['tabs', key]), value: value.toJson()};
  }
  deleteTabs(path) {
    return {type: 'DELETE', path: path.concat(['tabs'])};
  }
  deleteTabsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['tabs', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tabs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Compendium(this);
              copy._tabs = [];        for (let i of value) {
                copy._tabs.push(GeneralUIContent.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Compendium(this);
              copy._tabs = copy._tabs.concat([GeneralUIContent.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._tabs.length === 0) {
                return this;
              }
              const copy = new Compendium(this);
              copy._tabs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._tabs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Compendium(this);
              copy._tabs = copy._tabs.slice();
              copy._tabs[path[1]] = GeneralUIContent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Compendium(this);
              copy._tabs = copy._tabs.slice(0, path[1]).concat(copy._tabs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._tabs.length) {
            return this;
          }
          const oldValue = this._tabs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Compendium(this);
          copy._tabs = copy._tabs.slice();
          copy._tabs[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Compendium} other
   * @returns {Compendium}
   */
  merge(other) {
    const copy = new Compendium(this);
    copy._tabs = this._tabs.concat(other._tabs);
    return copy;
  }
}
Compendium.default = new Compendium();
class Compendium_Builder {
  constructor(value) {
    this._value = new Compendium(value);
  }
  build() {
    return new Compendium(this._value);
  }
  addAllTabs(values) {
    this._value._tabs = this._value._tabs.concat(values);
    return this;
  }
  addTabs(value) {
    this._value._tabs = this._value._tabs.concat([value]);
    return this;
  }
  setTabs(index, value) {
    this._value._tabs = this._value._tabs.concat();
    this._value._tabs[index] = value;
    return this;
  }
  clearTabs() {
    this._value._tabs = [];
    return this;
  }
}
Compendium.Builder = Compendium_Builder;
class Compendium_WithParent {
  /**
   * @param {Compendium} value
   * @param {Compendium_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Compendium.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfTabs() {
    if (!this._selfTabs) {
      this._selfTabs = [];
      for (let i of this._value.tabs) {
        this._selfTabs.push(new GeneralUIContent.WithParent(i, null));
      }
    }
    return this._selfTabs;
  }
  get inherentTabs() {
    if (!this._inherentTabs) {
      this._inherentTabs = this._parent ? this._parent.tabs : [];
    }
    return this._inherentTabs;
  }
  get tabs() {
    if (!this._allTabs) {
      this._allTabs = this._parent ? this._parent.tabs.concat(this.selfTabs) : this.selfTabs;
    }
    return this._allTabs;
  }
  update(current, parent) {
    const result = new Compendium_WithParent(current, parent);
    if (this._selfTabs) {
      if (this._value.tabs === current.tabs) {
        result._selfTabs = this._selfTabs;
      } else {
        result._selfTabs = [];
        for (let i = 0; i < current.tabs.length; i++) {
          const oldValue = this._value.tabs[i];
          if (oldValue) {
            const oldCache = this._selfTabs[i];
            if (oldValue === current.tabs[i]) {
              result._selfTabs[i] = oldCache;
            } else {
              result._selfTabs[i] = oldCache.update(current.tabs[i], null);
            }
          } else {
            result._selfTabs[i] = new GeneralUIContent.WithParent(current.tabs[i], null);
          }
        }
      }
    }
    return result;
  }
}
Compendium_WithParent.default = new Compendium_WithParent(Compendium.default, null);
Compendium.WithParent = Compendium_WithParent;
class Compendium_Descriptor {
  get tabs() {
    if (!this._tabs) {
      this._tabs = {
        name: "tabs",
        Name: "Tabs",
        number: 1,
        protoType: 11,
        protoName: "tabs",
        type: GeneralUIContent,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tabs;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tabs,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
Compendium.descriptor = new Compendium_Descriptor();
